import { ApiClient } from '../../../shared/api/ApiClient';

export interface CarrierServiceStatus {
  registered: boolean;
  carrierServiceId?: string;
  callbackUrl?: string;
}

export function getCarrierServiceStatus(
  api: ApiClient,
  shopDomain: string,
): Promise<CarrierServiceStatus> {
  const q = new URLSearchParams({ shopDomain });
  return api.get<CarrierServiceStatus>(`/admin/api/carrier-service?${q.toString()}`);
}

export function registerCarrierService(
  api: ApiClient,
  shopDomain: string,
): Promise<{ carrierServiceId: string }> {
  return api.post<{ carrierServiceId: string }>('/admin/api/carrier-service/register', {
    shopDomain,
  });
}

export function unregisterCarrierService(
  api: ApiClient,
  args: { id: string; shopDomain: string },
): Promise<void> {
  return api.delete<void>(`/admin/api/carrier-service/${args.id}`);
}
